<template>
  <ul role="presentation" class="list-none">
    <slot />
  </ul>
</template>

<script setup lang="ts">
import { injectListboxRootContext, type AcceptableValue } from "reka-ui"

// A slot child can use Reka's public context without reaching into PInputMenu refs.
const listbox = injectListboxRootContext()
function highlightFirstItem() {
  listbox.onKeydownNavigation(new KeyboardEvent("keydown", { key: "Home" }))
}
function highlightItem(element: HTMLElement) {
  listbox.changeHighlight(element, false, false)
}
// Use the same native selection operation as a Reka option, including multiple mode.
function selectItem(value: AcceptableValue) {
  listbox.onValueChange(value)
}
defineExpose({ highlightFirstItem, highlightItem, selectItem })
</script>

<script lang="ts">
import type { InjectionKey } from "vue"
import type { CustomComboboxOptionWrapper } from "@/components/form/custom-combobox-option-wrapper"

export const inputComboxActionKey: InjectionKey<
  (action: CustomComboboxOptionWrapper<any>) => void
> = Symbol("input-combox-action")
</script>
